module.exports = __webpack_public_path__ + "static/media/movies-stars.e2756f85.svg";